export default {
    loadCalendarEvents: { datapoint: { name: 'LoadCalendar' } },
    loadWeatherForecast: { datapoint: { name: 'WEATHER' } },
};
//# sourceMappingURL=datapoints.js.map